import { render } from "./ComboSegurado.vue?vue&type=template&id=d2d040d6&ts=true"
import script from "./ComboSegurado.vue?vue&type=script&lang=ts"
export * from "./ComboSegurado.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__